<template>
    <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :cell-style="bodyCellStyle"
        :height="tableHeight"
        stripe
        @selection-change="handleSelectionChange"
    >
        <el-table-column type="selection" width="55" />
        <el-table-column :label="$t('public.task')" show-overflow-tooltip prop="taskName">
            <template #default="{ row }">
                <span>
                    <i v-icon="['detectionTaskConvert', row.status]"></i>
                    <!-- <i :class="statusFn(row.status)" :title="titleFn(row.status)"></i> -->
                    {{ row.taskName }}</span
                >
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.table_scope')" show-overflow-tooltip prop="scopeId" v-if="$store.state.type === 3 || $store.state.type === 2">
            <template #default="{ row }">
                <span>
                    {{ customerFn(row.scopeId) }}
                </span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.check_item')" show-overflow-tooltip prop="taskContentName" />
        <el-table-column :label="$t('integration.detection_interval')" show-overflow-tooltip prop="interval">
            <template #default="{ row }">
                <span>
                    {{ intervalFn(row.interval, row.intervalUnit) }}
                </span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.table_operation')" prop="optate" width="140px" align="right">
            <template #default="{ row }">
                <el-button type="text" size="small" :title="$t('integration.deactivate')" v-if="row.status === 1" icon="el-icon-video-pause" @click="statusChangeFn(row)"> </el-button>
                <el-button type="text" size="small" :title="$t('integration.enable')" v-if="row.status === 0" icon="el-icon-video-play" @click="statusChangeFn(row)"></el-button>
                <template v-for="item in optareBtn">
                    <el-button v-if="generFn(item, row)" type="text" size="small" :key="item.id" :title="$t(item.title)" :icon="item.icon" @click="handle(item.method, row)"></el-button>
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: ['loading', 'tableData', 'customerArray'],
    data() {
        return {
            tableHeight: 'calc(100% - 60px)',
            optareBtn: [
                {
                    id: 3,
                    title: $t('integration.trigger'),
                    icon: 'el-icon-finished',
                    vHas: [],
                    method: 'triggerFn'
                },
                {
                    id: 4,
                    title: 'public.details',
                    icon: 'el-icon-tickets',
                    vHas: [],
                    method: 'detailFn'
                },
                {
                    id: 2,
                    title: $t('public.tbopt_delete'),
                    icon: 'el-icon-delete',
                    vHas: [],
                    method: 'delFn'
                }
            ]
        };
    },
    methods: {
        generFn(item, row) {
            let flag = true;
            if (item.id === 2) {
                flag = row.status === 0 ? true : false;
            } else if (item.id === 3) {
                flag = row.status === 1 ? true : false;
            }

            return flag;
        },
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg);
        },
        statusChangeFn(row) {
            this.$emit('statusChangeFn', row);
        },
        handle(method, row) {
            this.$emit(method, row);
        },
        customerFn(id) {
            let str = '';

            for (let item of this.customerArray) {
                if (Number(item.id) === id) {
                    str = item.name;
                    break;
                }
            }
            return str;
        },
        intervalFn(value, unit) {
            let str = unit === 0 ? $t('public.minute') : unit === 1 ? $t('integration.hour') : $t('integration.day');
            return value + str;
        }
    }
};
</script>

<style></style>
